import React from 'react';
import { InputAdornment, MenuItem, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ExpandMore } from '@mui/icons-material';
import { Controller, useFormContext } from 'react-hook-form';
import { COLORS } from '../../../utils/Application_Constants';
import { currencies, textFieldStyles } from '../../Configurations/ExpenseEntryConfig';

const styles = makeStyles((theme) => {
    const baseStyles = textFieldStyles(theme);
    return {
        ...baseStyles,
        selectIcon: {
            ...baseStyles.selectIcon,
            color: 'inherit',
            '&.Mui-disabled': {
                display: 'none',
            },
        },
        inputAdornmentRoot: {
            border: 'none',
            borderRadius: 0,
        },
        inputAdornmentSelect: {
            paddingRight: '32px !important',
            background: COLORS.LT_MIDNIGHT5,
            fontSize: '14px',
        },
        inputAdornmentDisabled: {
            paddingRight: '24px !important',
        },
        positionEnd: {
            marginLeft: 0,
        },
    };
});

export const AmountCurrencyInputAdornment = (props) => {
    const classes = styles();
    const { name, disabled, index, currencyType } = props;
    const { control } = useFormContext();

    return (
        <InputAdornment position="end" classes={{ positionEnd: classes.positionEnd }}>
            <Controller
                control={control}
                name={name ?? `expenseEntries[${index}].currency`}
                defaultValue={currencyType}
                render={({ onChange, value }) => (
                    <TextField
                        variant="standard"
                        id="expense-currency"
                        classes={{ root: classes.root }}
                        select
                        InputProps={{
                            classes: {
                                root: classes.inputAdornmentRoot,
                                input: classes.input,
                            },
                            disableUnderline: true,
                        }}
                        onChange={onChange}
                        value={value}
                        disabled={disabled}
                        SelectProps={{
                            classes: {
                                select: classes.inputAdornmentSelect,
                                icon: classes.selectIcon,
                                disabled: classes.inputAdornmentDisabled,
                            },
                            IconComponent: ExpandMore,
                            MenuProps: {
                                MenuListProps: { id: 'expense-currency-menu' },
                            },
                        }}
                    >
                        {currencies.map(
                            ({ name: currencyName, value: currencyValue }, currencyIndex) => (
                                <MenuItem
                                    key={currencyValue}
                                    value={currencyValue}
                                    id={`expense-currency-menu-option-${currencyIndex}`}
                                >
                                    {currencyName}
                                </MenuItem>
                            )
                        )}
                    </TextField>
                )}
            />
        </InputAdornment>
    );
};

export default AmountCurrencyInputAdornment;
